<template>
<section>
  <loading/>
  <div class="dosing">
    <div class="banner">
      <div class="banner-image">
        <img src="~@/assets/images/dosing-top.png" alt="DOSING PACKAGES">
      </div>
      <div class="overlay"></div>
      <div class="flexbox">
        <h1 id="banner-title" class="text-center">DOSING PACKAGES</h1>
      </div>
    </div>

    <div class="container main-content">
      <div class="main">
        <p>
          WATER GATE FLOW TECHNOLOGIES dosing pumps can offer different types of
          dosing pump systems according to clients' requirements.
        </p>
        <p>
          Reasonable and flexible internal design makes customization
          realizable. We can provide solutions for you according to user demand
          and special working conditions to avoid the embarrassing modification
          of process design upon the unsuitability of the product. We stick to
          the principle of providing clients with more professional and quicker
          support all the time. Through the experience and accumulation in the
          past years, we have comprehended both dosing pumps and the water
          treatment industry more profoundly. Our strong technical team can
          provide individualized products or compact electronic dosing systems
          centering on a dosing pump for your production process according to
          your particular requirements.
        </p>
        <h2>CUSTOMIZABLE SKIDS AND DOSING CABINS</h2>
        <p>
          WATER GATE FLOW TECHNOLOGIES dosing pumps can offer different types of
          dosing pump systems according to clients' requirements.
        </p>
        <p>
          Assembled solutions include electric control panels, designed and
          tested to operate the instruments.
        </p>

        <div class="image-card">
          <img src="~@/assets/images/SACDS.png" alt="" />
          <p class="caption">4-20mA Signal Automatic Control Dosing System</p>
        </div>
        <div class="image-card">
          <img src="~@/assets/images/CWSE.png" alt="" />
          <p class="caption">Cooling Water Smog Equipment</p>
        </div>
        <div class="image-card">
          <img
            src="~@/assets/images/cooling-water-smog-equipment-2.png"
            alt=""
          />
          <p class="caption">Cooling Water Smog Equipment</p>
        </div>
        <div class="image-card">
          <img
            src="~@/assets/images/cooling-water-smog-equipment-3.png"
            alt=""
          />
          <p class="caption">Cooling Water Smog Equipment</p>
        </div>
      </div>
      <div class="side-bar">
        <!-- <div class="dosing-sidebar">
        <div class="sidebar-header">
          <img
            src="~@/assets/images/dosing-sidebar-top-image.png"
            alt="dosing-sidebar-top-image"
          />
          <h2 class="sidebar-title">DOSING PUMPS</h2>
        </div>
        <ul>
          <li><a href="">Solenoid Dosing Pump</a></li>
          <li><a href="">Motor Driven Diaphragm Pump</a></li>
          <li><a href="">Metering Pump</a></li>
          <li><a href="">Diaphragm Pump</a></li>
          <li><a href="">Low Pressure Dosing Pump</a></li>
        </ul>
      </div> -->

        <div class="online-consult">
          <img
            src="~@/assets/images/consult-icon.png"
            alt="Online Consultation"
          />
          <p>Online Consultation</p>
        </div>
      </div>
    </div>
  </div>
  </section>
</template>

<script>
import loading from '../components/loading.vue';
export default {
  components: { loading },
  name: "Dosing",
};
</script>

<style lang="scss" scoped>
$color1: #065695;
$color2: #49b9e7;
$color3: #f1f1f1;

.dosing {
  background: #fff;
}

.dosing-content {
  display: flex;

  @media (max-width: 800px) {
    // padding: 5em 24px;
    flex-direction: column;
  }

  .dosing-main {
    margin: 1rem;
    width: 65%;
    line-height: 1.5rem;
    @media (max-width: 800px) {
      width: 100%;
      margin: 0;
    }

    p {
      margin: 1rem 0;
    }

    h2 {
      font-size: 1rem;
    }
  }

  .dosing-side {
    width: 35%;
    padding: 1em;
    @media (max-width: 800px) {
      width: 100%;
    }
  }
}

.image-card {
  margin: 2em 0;
  img {
    max-width: 100%;
    max-height: 250px;
    //  object-fit: cover;
  }
}

.online-consult {
  padding: 1.5em 2em;
  display: flex;
  width: fit-content;
  flex-direction: column;
  gap: 1em;
  align-items: center;
  color: #fff;
  background: #065695;
  border-radius: 8px;

  img {
    width: 24px;
  }
}

.container {
  margin: 1em 3rem;

  @media (max-width: 800px) {
    margin: 1em 24px;
  }
}
</style>